import React, { FunctionComponent } from 'react';
import {
    ThemeProvider as MuiProvider,
    ThemeProviderProps as MuiThemeProviderProps,
    createGenerateClassName,
    StylesProvider,
    useTheme,
    createStyles,
    makeStyles,
    alpha,
    ServerStyleSheets,
} from '@material-ui/core/styles';
import createTheme from './createTheme';
import tokens from './theme/tokens';

const createMuiTheme = createTheme;
const defaultTheme = createTheme();

export type { ThemeOptions } from './createTheme';
export type { ITheme as Theme } from './theme/palette';
export type ThemeProviderProps = MuiThemeProviderProps;

export const ThemeProvider: FunctionComponent<ThemeProviderProps> = ({ children, theme }: ThemeProviderProps) => {
    return <MuiProvider theme={theme || defaultTheme}>{children}</MuiProvider>;
};

ThemeProvider.defaultProps = {
    theme: defaultTheme,
};

/**
 * @deprecated since version 0.0.2
 */
export { tokens };

/**
 * @deprecated since version 0.0.14
 */
export {
    StylesProvider,
    createTheme,
    createMuiTheme,
    createStyles,
    createGenerateClassName,
    makeStyles,
    alpha,
    useTheme,
    ServerStyleSheets,
};
export default defaultTheme;
